import { useAuth } from 'utils/providers/AuthProvider'

import { Address, countriesMap, stateOptions, ukCountiesOptions } from 'shared'

export interface AddressFieldInfo {
  address: {
    label: string
    placeholder: string
    errorLabel: string
  }
  address2?: {
    label: string
    placeholder: string
    errorLabel: string
  }
  city: {
    label: string
    placeholder: string
    errorLabel: string
  }
  state: {
    label: string
    placeholder: string
    errorLabel: string
  }
  postalCode: {
    label: string
    placeholder: string
    errorLabel: string
  }
}

const useAddress = (userAddress?: Address | null) => {
  const { user } = useAuth()

  const userCountry = userAddress
    ? userAddress?.country
    : user?.profile?.address?.country

  const isUKBasedUser = userCountry === countriesMap.UK

  const statesOptions = isUKBasedUser ? ukCountiesOptions : stateOptions

  let addressField: AddressFieldInfo = {
    address: {
      label: 'Shipping address',
      placeholder: 'Enter shipping address',
      errorLabel: 'Address',
    },
    address2: {
      label: 'Unit Number',
      placeholder: 'Enter unit number',
      errorLabel: 'Unit Number',
    },
    city: {
      label: 'City',
      placeholder: 'Enter city',
      errorLabel: 'City',
    },
    state: {
      label: 'State',
      placeholder: 'Select a state',
      errorLabel: 'State',
    },
    postalCode: {
      label: 'Postal code',
      placeholder: 'Enter postal code',
      errorLabel: 'Postal code',
    },
  }

  switch (userCountry) {
    case countriesMap.UK: {
      addressField = {
        address: {
          label: 'Shipping address',
          placeholder: 'Enter shipping address',
          errorLabel: 'Address',
        },
        city: {
          label: 'Town/City',
          placeholder: 'Enter town or city',
          errorLabel: 'Town/City',
        },
        state: {
          label: 'County',
          placeholder: 'Select a county',
          errorLabel: 'County',
        },
        postalCode: {
          label: 'Postcode',
          placeholder: 'Enter postcode',
          errorLabel: 'Postcode',
        },
      }
      break
    }
    default:
      break
  }

  return {
    isUKBasedUser,
    addressField,
    statesOptions,
  }
}

export default useAddress
